export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Meus Boletos',
    route: 'bank-slips',
    icon: 'DollarSignIcon',
  },
  {
    title: 'Meu contrato',
    route: 'contract-resume',
    icon: 'FileTextIcon',
  },
  {
    title: 'Imposto de renda',
    route: 'income-tax',
    icon: 'FileTextIcon',
  },
]
